<template>
  <div class="modalmatch">
    <el-tabs v-model="activeTab" type="border-card" class="dense">
      <el-tab-pane name="street-turns">
        <span slot="label"> <i class="fas fa-cubes" /> Street Turns </span>
        <StreetTurnRequests />
      </el-tab-pane>
    </el-tabs>
    <chat-popup />
  </div>
</template>
<script>
import StreetTurnRequests from "@/default/pages/modalmatch/street_turn_requests.vue";
export default {
  name: "Modalmatch",
  components: {
    StreetTurnRequests,
  },
  data() {
    return {
      activeTab: "street-turns",
    };
  },
};
</script>
<style lang="scss" scoped>
.modalmatch::v-deep {
  .el-tabs__item {
    padding: 0px 20px !important;
  }
}
</style>
